export default __webpack_public_path__ + "static/media/wojtkow.227fd6c3.webp";